export default __webpack_public_path__ + "static/media/badge-on-contrast.2fc7f5bf.svg";